import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import SearchIconMDI from 'mdi-react/MagnifyIcon';
import CloseIcon from 'mdi-react/CloseIcon';
import { bemGenerator, noop } from '@prisjakt/ui-base';
import { AppContext } from '@prisjakt/ui-app-context';
import actions from '../../actions';
import './index.scss';

const styles = bemGenerator('campaign-search-agg', [
  'title',
  'input',
  'clear',
  'search',
]);

const SearchIcon = styled(SearchIconMDI).attrs(p => ({
  color: p.theme.icons.quaternary,
}))``;

class Search extends React.PureComponent {
  render() {
    const { t } = this.context;
    // Clear the search input if no query is given
    if (!this.props.query && this.searchInput) {
      this.searchInput.value = '';
    }
    return (
      <div className={styles.block}>
        <input
          className={styles.input.withModifier({
            empty: !this.props.query,
          })}
          onBlur={e => {
            if (e.currentTarget.value) {
              this.props.campaignSearchDone();
            }
          }}
          defaultValue={this.props.query}
          placeholder={t('campaigns', 'search.placeholder', {
            campaign: this.props.campaignName,
          })}
          type="search"
          onChange={e =>
            this.props.onSearch({
              id: 'query',
              value: e.currentTarget.value,
            })
          }
          ref={input => {
            this.searchInput = input;
            if (this.searchInput) {
              this.searchInput.value = this.props.query || '';
            }
          }}
        />
        {(this.searchInput && this.searchInput.value.length) ||
        this.props.query ? (
          <button
            type="button"
            className={styles.clear}
            onClick={() => {
              this.props.onSearch({ id: 'query', value: '' });
              this.searchInput.value = '';
              this.searchInput.focus();
            }}
          >
            <CloseIcon height={12} />
          </button>
        ) : (
          <button
            type="button"
            className={styles.search}
            onClick={() => {
              this.searchInput.focus();
            }}
          >
            <SearchIcon size={20} />
          </button>
        )}
      </div>
    );
  }
}

const { func, string } = PropTypes;

Search.propTypes = {
  query: string,
  onSearch: func,
  campaignSearchDone: func.isRequired,
  campaignName: string,
};

Search.defaultProps = {
  query: undefined,
  onSearch: noop,
  campaignName: '',
};

Search.contextType = AppContext;

export default connect(null, actions)(Search);
